<template>
  <multiple_form
    :forms="forms"
    :edit="props.isEdit"
    :editData="props.editData"
    :itemCol="24"
    @submit="handelSubmit"
  />
</template>
<script setup>
  import { defineProps, defineEmits, computed } from 'vue'
  import { message } from 'ant-design-vue'
  import {
    createData,
    updateData,
  } from '@/api/equipment_management/buried_electronic_tire_breaker'
  import multiple_form from '@/components/multiple_form'
  import { blackWhiteListType } from '@/utils/common'
  import { constantToOptions } from '@/utils/format'
  //初始化
  const props = defineProps({
    isEdit: Boolean,
    editData: Object,
    data: Array,
    idField: String,
  })
  const emit = defineEmits(['submit'])

  //编辑、新增的表单
  const forms = computed(() => [
    {
      id: 'car_person',
      itemWidth: '470px',
      formItem: [
        {
          type: 'input',
          field: 'name',
          label: '设备名称',
        },
        {
          type: 'input',
          field: 'number',
          label: '设备编号',
        },
        {
          type: 'addressPicker',
          latField: 'lat',
          lngField: 'lng',
          label: '经纬度(GCJ-02)',
        },
      ],
    },
  ])

  async function handelSubmit(data) {
    const ajaxFn = props.isEdit ? updateData : createData
    const messageText = props.isEdit ? '编辑' : '创建'
    const id = props.isEdit
      ? { [props.idField]: props.editData[props.idField] }
      : {}
    const res = await ajaxFn({ ...data, ...id })
    if (res.success) {
      message.success(messageText + '成功！')
      emit('submit')
    } else {
      message.warn(messageText + '错误：', res.message)
    }
  }
</script>
